// extracted by mini-css-extract-plugin
export var searchHeader = "_7m-0";
export var searchHeaderDark = "_7m-1";